{
  "RESET_PASSWORD": {
    "TITLE": "Reset password",
    "DESCRIPTION": "Enter the email address you use to log in to Contact Center to get the password reset instructions.",
    "GO_BACK_TO_LOGIN": "If you want to go back to the login page,",
    "EMAIL": {
      "LABEL": "Email",
      "PLACEHOLDER": "Please enter your email.",
      "ERROR": "Please enter a valid email."
    },
    "API": {
      "SUCCESS_MESSAGE": "Password reset link has been sent to your email.",
      "ERROR_MESSAGE": "Could not connect to chat server. Please try again."
    },
    "SUBMIT": "Submit"
  }
}
